/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-08-11 14:06:57
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\layouts\IndexLayout\routes.ts
 */
import settings from "@/config/settings";
import { RoutesDataItem } from "@/utils/routes";
import BlankLayout from '@/layouts/BlankLayout.vue';

const IndexLayoutRoutes: Array<RoutesDataItem> = [
  /*
  {
    title: 'index-layout.menu.home',
    path: '/home',
    component: ()=> import('@/views/home/index.vue')
  }, */
  {
    icon: 'home',
    title: 'index-layout.menu.home',
    path: '/home',
    redirect: settings.homeRouteItem.path,
    component: BlankLayout,
    children: [
      {
        ...settings.homeRouteItem,
      },
      {
        title:'运费计算器',
        path: 'freightcalculation',
        hidden: true,
        component: () => import('@/views/home/component/freightcalculation/index.vue'),
      },
      {
        title:'产品说明详情',
        path: 'productInfo',
        hidden: true,
        component: () => import('@/views/home/component/productInfo/index.vue'),
      },
      {
        title:'上门揽收范围',
        path: 'collectionInfo',
        hidden: true,
        component: () => import('@/views/home/component/collectionInfo/index.vue'),
      },
      {
        title:'自送站点服务范围',
        path: 'selfdeliveryInfo',
        hidden: true,
        component: () => import('@/views/home/component/selfdeliveryInfo/index.vue'),
      },
      {
        title:'邮寄站点服务范围',
        path: 'mailInfo',
        hidden: true,
        component: () => import('@/views/home/component/mailInfo/index.vue'),
      },
      {
        title:'禁运品清单',
        path: 'embargoInfo',
        hidden: true,
        component: () => import('@/views/home/component/embargoInfo/index.vue'),
      },
    ],
  },
  {
    icon:'set',
    title: 'index-layout.menu.roles.personal',
    path: '/personal',
    component: BlankLayout,
    children: [
      {
        icon: '',
        title: 'index-layout.menu.roles.personal.account',
        path: 'account',
        component: ()=>import('@/views/personal/authent/index.vue')
      },
      {
        icon: '',
        title: '合同管理',
        path: 'contract',
        component: ()=>import('@/views/personal/contract/index.vue')
      }
    ]
  },
  {
    icon:'control',
    title: 'index-layout.menu.roles.account',
    path: '/account',
    component: BlankLayout,
    children: [
      {
        icon: '',
        title: 'index-layout.menu.roles.account.query',
        path: 'query',
        component: ()=>import('@/views/account/accountquery/index.vue')
      },
      {
        icon: '',
        title: 'index-layout.menu.roles.account.recharge',
        path: 'recharge',
        component: ()=>import('@/views/account/recharge/index.vue')
      },
      {
        icon: '',
        title: 'index-layout.menu.roles.account.logistics',
        path: 'logistics',
        component: ()=>import('@/views/account/logistics/index.vue')
      }
    ]
  },
  {
    icon:'page',
    title: 'index-layout.menu.roles.logistics',
    path: '/logistics',
    component: BlankLayout,
    children: [
      {
        icon: '',
        title: 'index-layout.menu.roles.logistics.query',
        path: 'query',
        component: ()=>import('@/views/logistics/logisticsquery/index.vue')
      },
      {
        title:'创建物流单',
        path: 'addlogistics',
        // hidden: true,
        component: () => import('@/views/addlogistics/index.vue'),
      },
      {
        icon: '',
        title: '物流轨迹查询',
        path: 'logisticstrack',
        component: ()=>import('@/views/logistics/logisticstrack/index.vue')
      },
      {
        icon: '',
        title: 'index-layout.menu.roles.logistics.erp',
        path: 'erp',
        component: ()=>import('@/views/logistics/erp/index.vue')
      },
      // {
      //   icon: '',
      //   title: 'index-layout.menu.roles.logistics.sku',
      //   path: 'sku',
      //   component: ()=>import('@/views/logistics/sku/index.vue'){
      //     icon:'page',
      //     title: 'index-layout.menu.roles.tms',
      //     path: '/tms',
      //     component: BlankLayout,
      //     children: [
      //       {
      //         icon: '',
      //         title: 'index-layout.menu.roles.tms.airlineorderment',
      //         path: 'airlineorderment',
      //         component: ()=>import('@/views/tms/airlineorderment/index.vue')
      //       },
      //       {
      //         icon: '',
      //         title: 'index-layout.menu.roles.tms.datamanagement',
      //         path: 'datamanagement',
      //         component: ()=>import('@/views/tms/datamanagement/index.vue')
      //       },
      //       {
      //         icon: '',
      //         title: 'index-layout.menu.roles.tms.systemlogs',
      //         path: 'systemlogs',
      //         component: ()=>import('@/views/tms/systemlogs/index.vue')
      //       }
      //     ]
      //   }
      // },
      // {
      //   icon: '',
      //   title: 'index-layout.menu.roles.logistics.collectbill',
      //   path: 'collectbill',
      //   component: ()=>import('@/views/logistics/collectbill/index.vue')
      // },
      {
        icon: '',
        title: 'index-layout.menu.roles.logistics.address',
        path: 'address',
        component: ()=>import('@/views/logistics/customer/index.vue')
      }
    ]
  },

];

export default IndexLayoutRoutes;
